export default (id) => {
  window.dispatchEvent(new CustomEvent('itemAdd', { detail: { id } }));
};
